import React from 'react';
import {AutoField} from 'components/forms/fields';
import Section from 'components/forms/Section';
import {Typography} from '@material-ui/core';
import fields from 'components/forms/uscgtoss/fields';
import {bootstrapOldForm} from 'components/forms/AutoSection';

const DateOfTranscript = props => {
    const {schema, initialValues, sectionFields} = bootstrapOldForm(
        'Date of Transcript',
        fields
    );

    return (
        <Section {...props} schema={schema} initialValues={initialValues}>
            <Typography variant='h6' align='left'>
                Date of Transcript
            </Typography>
            {sectionFields.map(field => (
                <AutoField field={fields[field]} name={field} key={field} />
            ))}
            {props.children}
        </Section>
    );
};

export default DateOfTranscript;
